import { JsonConvertableImpl, BpmnModelJsonHelper } from '@edp-bif/common-api';
import { BifMetadataType } from './BifMetadataType';
import { IShowEntity } from './IShowEntity';

export abstract class AbstractShowEntity extends JsonConvertableImpl implements IShowEntity {
    id: string;
    code: string;
    name: string;
    upBillVoName: string;
    downBillVoName: string;
    bifMetadataType: BifMetadataType;
    lastModifiedTime: Date;
    parentId: string;
    sysInit: boolean = false;
    originId: string;
    rootId: string;

    protected ResetBeforeLoadFrom(): void {
        super.ResetBeforeLoadFrom();

        this.id = null;
        this.code = null;
        this.name = null;
        this.upBillVoName = null;
        this.downBillVoName = null;
        this.parentId = null;
        this.bifMetadataType = null;
        this.lastModifiedTime = null;
        this.sysInit = false;
        this.originId = null;
        this.rootId = null;
    }

    public ConvertToJsonObject(): {} {
        let obj = super.ConvertToJsonObject();

        BpmnModelJsonHelper.SetAttributeValue(obj, "id", this.id);
        BpmnModelJsonHelper.SetAttributeValue(obj, "code", this.code);
        BpmnModelJsonHelper.SetAttributeValue(obj, "name", this.name);
        BpmnModelJsonHelper.SetAttributeValue(obj, "upBillVoName", this.upBillVoName);
        BpmnModelJsonHelper.SetAttributeValue(obj, "downBillVoName", this.downBillVoName);
        BpmnModelJsonHelper.SetAttributeValue(obj, "parentId", this.parentId);
        BpmnModelJsonHelper.SetAttributeValue(obj, "bifMetadataType", this.bifMetadataType);
        BpmnModelJsonHelper.SetAttributeValue(obj, "lastModifiedTime", this.lastModifiedTime);
        BpmnModelJsonHelper.SetAttributeValue(obj, "sysInit", this.sysInit);
        BpmnModelJsonHelper.SetAttributeValue(obj, "originId", this.originId);
        BpmnModelJsonHelper.SetAttributeValue(obj, "rootId", this.rootId);

        return obj;
    }

    public LoadFromJsonObject(obj: {}): void {
        super.LoadFromJsonObject(obj);

        this.id = BpmnModelJsonHelper.GetAttributeValueAsString(obj, "id");
        this.code = BpmnModelJsonHelper.GetAttributeValueAsString(obj, "code");
        this.name = BpmnModelJsonHelper.GetAttributeValueAsString(obj, "name");
        this.upBillVoName = BpmnModelJsonHelper.GetAttributeValueAsString(obj, "upBillVoName");
        this.downBillVoName = BpmnModelJsonHelper.GetAttributeValueAsString(obj, "downBillVoName");
        this.parentId = BpmnModelJsonHelper.GetAttributeValueAsString(obj, "parentId");
        this.bifMetadataType = BifMetadataType[BpmnModelJsonHelper.GetAttributeValueAsString(obj, "bifMetadataType")];
        this.lastModifiedTime = BpmnModelJsonHelper.GetAttributeValueAsDateTime(obj, "lastModifiedTime");
        this.sysInit = BpmnModelJsonHelper.GetAttributeValueAsBoolean(obj, "sysInit");
        this.originId = BpmnModelJsonHelper.GetAttributeValueAsString(obj, "originId");
        this.rootId = BpmnModelJsonHelper.GetAttributeValueAsString(obj, "rootId");
    }
}